<div [class]="skinName">
  @if (!logged_in) {
    <app-navigation [guest]="false"></app-navigation>
  }
  <div class="watch-page">
    <div class="watch-bg-container">
      <div class="where-to-watch-title">{{ configService.localeKeys?.watch_filmbox_title }}</div>
    </div>
    <!-- <div *ngIf="!logged_in" class="join-now-block">
    <div class="join-now-row">
      <div class="row join-row">
        <div class="join-now-para d-flex align-items-center col-8" >{{ configService.localeKeys?.unlimited_movies_part_1 }} {{planInfo}}</div>
        <button class="btn join-now-btn ml-auto col-4 col-lg-2" [routerLink]="['/auth/signup']">{{configService.localeKeys?.join_now_button}}</button>
      </div>
    </div>
  </div> -->
  <div class="detail-block">
    <div class="tabs">
      <input type="radio" name="tab" id="smartTv" checked="checked">
      <input type="radio" name="tab" id="setTopBox">
      <input type="radio" name="tab" id="mediaPlayer">
      <input type="radio" name="tab" id="smartphone">
      <input type="radio" name="tab" id="pcLaptop">
      <div class="tab-list" id="scroll-bar">
        <label #smartLabel id="smartLabel" (click)="showContent($event, smartLabel)" for="smartTv">{{ configService.localeKeys?.['where_to_watch.smart_tv.title'] }}</label>
        <label #setTopboxLabel id="setTopboxLabel" (click)="showContent($event, setTopboxLabel)" for="setTopBox">{{ configService.localeKeys?.['where_to_watch.set_top_box.title'] }}</label>
        @if (appName != 'readingcorner') {
          <label #mediaPLayerLabel id="mediaPLayerLabel" (click)="showContent($event, mediaPLayerLabel)" for="mediaPlayer">{{ configService.localeKeys?.['where_to_watch.streaming_media_player.title'] }}</label>
        }
        <label #smartphoneLabel id="smartphoneLabel" (click)="showContent($event, smartphoneLabel)" for="smartphone">{{ configService.localeKeys?.['where_to_watch.smartphones_tablets.title'] }}</label>
        <label #laptopLabel id="laptopLabel" (click)="showContent($event, laptopLabel)" for="pcLaptop">{{ configService.localeKeys?.['where_to_watch.pc_laptops.title'] }}</label>
      </div>
      <div class="tab-content-wrapper">
        @if (contentData.smartTv) {
          <div id="smartTvContent" class="tab-content">
            <app-device-accordion [deviceType]="device1" [samrtTVInfo]="samrtTVInfo"></app-device-accordion>
          </div>
        }
        @if (contentData.setTopBox) {
          <div id="setTopBoxContent" class="tab-content">
            <app-device-accordion [deviceType]="device2" [samrtTVInfo]="setTopBoxInfo"></app-device-accordion>
          </div>
        }
        @if (contentData.mediaPlayer) {
          <div id="mediaPlayerContent" class="tab-content">
            <app-device-accordion [deviceType]="device3" [samrtTVInfo]="mediaPlayerInfo"></app-device-accordion>
          </div>
        }
        @if (contentData.smartphone) {
          <div id="smartphoneContent" class="tab-content">
            <app-device-accordion [deviceType]="device4" [samrtTVInfo]="smartphoneInfo"></app-device-accordion>
          </div>
        }
        @if (contentData.pcLaptop) {
          <div id="pcLaptopContent" class="tab-content">
            <app-device-accordion [deviceType]="device5"></app-device-accordion>
          </div>
        }
      </div>
    </div>
  </div>
</div>

</div>